import { useAuthorizedUser } from "src/features/auth/useAuthorizedUser";
import { pagesPath } from "src/utils/$path";

export const useWorkspacePagesPath = () =>
  pagesPath.w._workspaceId(useAuthorizedUser().currentWorkspace.id);
